import * as Yup from "yup";
import i18n from "../i18n";

export const DepartmentsSchema = Yup.object({
  departmentEn: Yup.string().required(
    i18n.language === "en"
      ? "Department (English) is required"
      : "القسم (بالإنجليزية) مطلوب"
  ),
  departmentAr: Yup.string().required(
    i18n.language === "en"
      ? "Department (Arabic) is required"
      : "القسم (بالعربية) مطلوب"
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required." : "الموقع مطلوب."
  ),
  building: Yup.string().required(
    i18n.language === "en" ? "Building is required." : "المبنى مطلوب."
  ),
  description: Yup.string().nullable(),
});
